module.exports = __webpack_public_path__ + "static/media/48281605_2308805115861333_3269498842822737920_o.fc4eb4cb.jpg";